//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { Activity, Enums } from "../../models/common"

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"

//#region Public Types

export const OPERATOR_CONTEXT_MENU_SERVICE_NAME = 'operatorContextMenuService'
export const OPERATOR_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'operatorContextMenuServiceProvider'

export type IdOperatorGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onCopy?: () => void
    onEdit?: () => void
}

//#endregion

export class OperatorContextMenuService {

    // #region Ctor

    public constructor(
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: IdOperatorGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        if (options.onEdit != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.OPERATOR_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),

                onItemClick: (e: any) => {
                    options.onEdit()
                },
            })
        }

        if (
            options.onCopy != null
            && _.size(options.idReferenceTypes) === 1
            && this.userSessionService.getLoggedOperator().hasPermission(Activity.OPERATOR_COPY)
        ) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Copy), ConfigHelper.Icon.CONTENT_COPY, this.userSessionService),

                onItemClick: (e: any) => {
                    options.onCopy()
                }
            })
        }


        return items
    }

    // #endregion
}

export class OperatorContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSessionService: UserSessionService) {
        return new OperatorContextMenuService(userSessionService)
    }]

    //#endregion
} 
